import cn from 'classnames';
import type { Description } from '@/api/cms/types';

type Props = {
  items: Description[];
  className?: string;
};

export default function SliderDescriptionItem(props: Props) {
  return (
    <article
      className={cn(
        'flex flex-col items-center justify-start space-y-6',
        props.className
      )}
    >
      {props.items.map((item, idx) => (
        <div key={idx} className="flex flex-col space-y-2">
          <h4 className="text-body16 font-bold text-neutral-50">
            {item.label}
          </h4>
          <p className="text-subtitle18 font-bold text-black">{item.value}</p>
        </div>
      ))}
    </article>
  );
}
